import React from 'react';
import styled from 'styled-components';
import constants from '@/core/constants';

const ContainerModal = styled.div`
  width: 100vw;
  height: 100vh;
  position: fixed;
  display: flex;
  z-index: 12;
  top: 0px;
  left: 0px;
  align-items: center;
  justify-content: center;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.4s ease, visibility 0.4s ease;
  &.active {
    opacity: 1;
    visibility: visible;
  }
`;
const WrapLayer = styled.div`
  width: 100vw;
  height: 100vh;
  background: #283044;
  z-index: 10;
  position: fixed;
  display: flex;
  transition: background 0.2s, display 0.3s linear;
  &.active {
    display: none;
  }

  @media (min-width: ${constants.BREAKPOINT_SIZE}px) {
  }
`;

const WrapContainer = styled.div.attrs((props: any) => ({
  backgroundColor: props.backgroundColor || '#fff'
}))`
  width: 100vw;
  background-color: ${(props) => props.backgroundColor};
  z-index: 10;
  display: flex;
  flex-direction: column;
  transition: position 0.2s, display 0.3s linear;
  & > .icon {
    display: flex;
    justify-content: flex-end;
    min-height: 40px;
    padding: 0px 11px;
    align-items: center;
    cursor: pointer;
  }
  & > .icon cc-icon {
    color: var(--interaction-detail);
    cursor: pointer;
  }
`;
const BoxContainer = (props: any) => {
  const { children, IsModalOpen } = props;

  return (
    <ContainerModal
      className={`${IsModalOpen ? 'active' : ''}`}
      data-testid="cmp-LightBox"
    >
      <WrapLayer>
        <WrapContainer>{children}</WrapContainer>
      </WrapLayer>
    </ContainerModal>
  );
};

export default BoxContainer;
